import { render, staticRenderFns } from "./createNewFamily.vue?vue&type=template&id=142fb74e&scoped=true"
import script from "./createNewFamily.vue?vue&type=script&lang=js"
export * from "./createNewFamily.vue?vue&type=script&lang=js"
import style0 from "./createNewFamily.vue?vue&type=style&index=0&id=142fb74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142fb74e",
  null
  
)

export default component.exports